const formatMobile = (mobile) => {
  let res = mobile.split("");
  res[4] = "-" + res[4];
  res[7] = "-" + res[7];
  res[9] = "-" + res[9];
  res = res.join("");
  res = res.replace("-", " ").replace("-", " ").replace("-", " ");
  return res;
};

export default {
  formatMobile,
};
